<cbc-container [isLoading]="isLoading" [showContainer]="!isLoading" title="Negociações">
</cbc-container>

@if(!isLoading) {
  <div class="container" [class.is_mobile]="isMobile">

    <div class="swiper-menu">
      <div class="mini-card-container">
        <div class="mini-card" [class.selected]="selectedTab.value === 'tab1'" (click)="selectedTab.setValue('tab1')">
          <img src="assets/icons/icon_negociacoes_emandamento.svg" alt="Negociações em Andamento" width="40px">
          <span>{{ isMobile ? 'Em Andamento' : 'Negociações em Andamento' }}</span>
        </div>

        <div class="mini-card" [class.selected]="selectedTab.value === 'tab2'" (click)="selectedTab.setValue('tab2')">
          <img src="assets/icons/icon_negociacoes_concluidas.svg" alt="Negociações Concluídas" width="40px">
          <span>{{ isMobile ? 'Concluídas' : 'Negociações Concluídas' }}</span>
        </div>
      </div>
    </div>
 

  <swiper-container #swiper class="swiper" pagination="false" autoplay="false">
    <!-- TAB 1: Negociações em Andamento -->
    <swiper-slide>
      <div class="slideContainer">
        <ng-container *ngIf="!isMobile; else mobileOpen">
          <div *ngIf="getNegotiationsOpen().length === 0" class="empty-state">
            <mat-icon>info</mat-icon>
            <p>Nenhuma negociação em andamento</p>
          </div>

          <div *ngIf="getNegotiationsOpen().length > 0" class="table-wrapper responsive-table" role="region"
            aria-label="Negociações em Andamento - tabela">
            <table mat-table [dataSource]="getNegotiationsOpen()" class="mat-elevation-z1">
              <ng-container matColumnDef="id">
                <th mat-header-cell *matHeaderCellDef>ID:</th>
                <td mat-cell *matCellDef="let element">{{ element.id }}</td>
              </ng-container>

              <ng-container matColumnDef="initiatorCpfCnpj">
                <th mat-header-cell *matHeaderCellDef>Iniciador:</th>
                <td mat-cell *matCellDef="let element">

                  @if(element.initiatorCpfCnpj.length === 11) {
                  <ng-container *ngIf="getProfilePFDto(element.initiatorCpfCnpj) as profilePFDto">
                    {{ profilePFDto.name }}
                    @if(profilePFDto.certifiedHubMedical) {
                    <img src="assets/icons/icon_certificado_concedido.svg" alt="Certificado Hub Medical"
                      matTooltip="Certificado Hub Medical" width="20px" height="20px" />
                    } @else {
                    <img src="assets/icons/icon_certificado_ausente.svg" alt="Não certificado"
                      matTooltip="Não certificado" width="20px" height="20px" />
                    }
                  </ng-container>
                  } @else {
                  <ng-container *ngIf="getCompanyDto(element.initiatorCpfCnpj) as companyDto">
                    {{ companyDto.companyName }}
                    @if(companyDto.certifiedHubMedical) {
                    <img src="assets/icons/icon_certificado_concedido.svg" alt="Certificado Hub Medical"
                      matTooltip="Certificado Hub Medical" width="20px" height="20px" />
                    } @else {
                    <img src="assets/icons/icon_certificado_ausente.svg" alt="Não certificado"
                      matTooltip="Não certificado" width="20px" height="20px" />
                    }
                  </ng-container>}
                </td>
              </ng-container>

              <ng-container matColumnDef="recipientCpfCnpj">
                <th mat-header-cell *matHeaderCellDef>Destinatário:</th>
                <td mat-cell *matCellDef="let element">

                  @if(element.recipientCpfCnpj.length === 11) {
                  <ng-container *ngIf="getProfilePFDto(element.recipientCpfCnpj) as profilePFDto">
                    {{ profilePFDto.name }}
                    @if(profilePFDto.certifiedHubMedical) {
                    <img src="assets/icons/icon_certificado_concedido.svg" alt="Certificado Hub Medical"
                      matTooltip="Certificado Hub Medical" width="20px" height="20px" />
                    } @else {
                    <img src="assets/icons/icon_certificado_ausente.svg" alt="Não certificado"
                      matTooltip="Não certificado" width="20px" height="20px" />
                    }
                  </ng-container>
                  } @else {
                  <ng-container *ngIf="getCompanyDto(element.recipientCpfCnpj) as companyDto">
                    {{ companyDto.companyName }}
                    @if(companyDto.certifiedHubMedical) {
                    <img src="assets/icons/icon_certificado_concedido.svg" alt="Certificado Hub Medical"
                      matTooltip="Certificado Hub Medical" width="20px" height="20px" />
                    } @else {
                    <img src="assets/icons/icon_certificado_ausente.svg" alt="Não certificado"
                      matTooltip="Não certificado" width="20px" height="20px" />
                    }
                  </ng-container>}
                </td>

              </ng-container>

              <ng-container matColumnDef="createdAt" style="text-align: center;">
                <th mat-header-cell *matHeaderCellDef>Criado em:</th>
                <td mat-cell *matCellDef="let element">{{ element.createdAt | date : 'dd/MM/yyyy HH:mm' }}</td>
              </ng-container>

              <ng-container matColumnDef="status">
                <th mat-header-cell *matHeaderCellDef>Status:</th>
                <td mat-cell *matCellDef="let element">
                  <span class="badge badge-primary">{{ element.status | enumDescription }}</span>
                </td>
              </ng-container>

              <ng-container matColumnDef="buttons">
                <th mat-header-cell *matHeaderCellDef></th>
                <td mat-cell *matCellDef="let element">
                  <button mat-icon-button [matMenuTriggerFor]="menu" [matBadge]="countNotRead(element.id)" 
                          [matBadgeHidden]="!countNotRead(element.id)">
                    <mat-icon>more_vert</mat-icon>
                  </button>
                  <mat-menu #menu="matMenu">
                    @if(element.status.includes('ACCEPTED') || element.status.includes('IN_PROGRESS') ){
                    <button mat-menu-item (click)="openDialogChat(element.id)">
                      <mat-icon>chat</mat-icon>
                      <span>Abrir Chat</span>
                    </button>
                    }
                    @if (element.status.includes('PENDING') && element.recipientCpfCnpj === participantCpfCnpj ){
                    <button mat-menu-item (click)="changeStatusToAccepted(element.id)">
                      <mat-icon>check_circle</mat-icon>
                      <span>Aceitar Convite</span>
                    </button>
                    <button mat-menu-item (click)="changeStatusToRejected(element.id)">
                      <mat-icon>cancel</mat-icon>
                      <span>Rejeitar Convite</span>
                    </button>
                    }
                    @if (element.status.includes('PENDING') || !element.status.includes('CLOSED')){
                    <button mat-menu-item (click)="changeStatusToClose(element.id)">
                      <mat-icon>close</mat-icon>
                      <span>Encerrar Negociação</span>
                    </button>
                    }
                  </mat-menu>
                </td>
              </ng-container>

              <tr mat-header-row *matHeaderRowDef="displayedColumnsOpen" [class.tr_header]="isMobile"></tr>
              <tr mat-row *matRowDef="let row; columns: displayedColumnsOpen"></tr>
            </table>
          </div>
        </ng-container>

        <ng-template #mobileOpen>
          <div class="mobile-list">
            <div *ngIf="getNegotiationsOpen().length === 0" class="empty-state">
              <mat-icon>info</mat-icon>
              <p>Nenhuma negociação em andamento</p>
            </div>

            <article *ngFor="let element of getNegotiationsOpen()" class="card" role="group">
              <div class="mobile-card-row">
                <span class="mobile-card-label">ID:</span>
                <span class="mobile-card-value">{{ element.id }}</span>
              </div>
              <div class="mobile-card-row">
                <span class="mobile-card-label">Iniciador:</span>
                <span class="mobile-card-value">{{ element.initiatorCpfCnpj }}</span>
              </div>
              <div class="mobile-card-row">
                <span class="mobile-card-label">Destinatário:</span>
                <span class="mobile-card-value">{{ element.recipientCpfCnpj }}</span>
              </div>
              <div class="mobile-card-row">
                <span class="mobile-card-label">Criado em:</span>
                <span class="mobile-card-value">{{ element.createdAt | date : 'dd/MM/yyyy - HH:mm' }}</span>
              </div>
              <div class="mobile-card-row">
                <span class="mobile-card-label">Status:</span>
                <span class="badge badge-primary">{{ element.status! | enumDescription }}</span>
              </div>
              <div class="mobile-card-actions">

                <button mat-icon-button [matMenuTriggerFor]="menuMobile" [matBadge]="countNotRead(element.id!)" 
                        [matBadgeHidden]="!countNotRead(element.id!)">
                  <mat-icon>more_vert</mat-icon>
                </button>
                <mat-menu #menuMobile="matMenu">
                  @if(element?.status && (element.status?.includes('ACCEPTED') ||
                  element.status?.includes('IN_PROGRESS'))){
                  <button mat-menu-item (click)="openDialogChat(element.id!)">
                    <mat-icon>chat</mat-icon>
                    <span>Abrir Chat</span>
                  </button>
                  }
                  @if (element.status?.includes('PENDING') && element.recipientCpfCnpj ===
                  participantCpfCnpj ){
                  <button mat-menu-item (click)="changeStatusToAccepted(element.id!)">
                    <mat-icon>check_circle</mat-icon>
                    <span>Aceitar Convite</span>
                  </button>
                  <button mat-menu-item (click)="changeStatusToRejected(element.id!)">
                    <mat-icon>cancel</mat-icon>
                    <span>Rejeitar Convite</span>
                  </button>
                  }
                  @if (element.status?.includes('PENDING') || !element.status?.includes('CLOSED')){
                  <button mat-menu-item (click)="changeStatusToClose(element.id!)">
                    <mat-icon>close</mat-icon>
                    <span>Encerrar Negociação</span>
                  </button>
                  }
                </mat-menu>
              </div>
            </article>
          </div>
        </ng-template>
      </div>
    </swiper-slide>

    <!-- TAB 2: Negociações Concluídas -->
    <swiper-slide>
      <div class="slideContainer">
        <ng-container *ngIf="!isMobile; else mobileClose">
          <div *ngIf="getNegotiationsClosed().length === 0" class="empty-state">
            <mat-icon>info</mat-icon>
            <p>Nenhuma negociação concluída</p>
          </div>

          <div *ngIf="getNegotiationsClosed().length > 0" class="table-wrapper responsive-table" role="region">
            <table mat-table [dataSource]="getNegotiationsClosed()" class="mat-elevation-z1">
              <ng-container matColumnDef="id">
                <th mat-header-cell *matHeaderCellDef>ID:</th>
                <td mat-cell *matCellDef="let element">{{ element.id }}</td>
              </ng-container>

              <ng-container matColumnDef="initiatorCpfCnpj">
                <th mat-header-cell *matHeaderCellDef>Iniciador:</th>
                <td mat-cell *matCellDef="let element">
                  @if(element.initiatorCpfCnpj.length === 11) {
                  <ng-container *ngIf="getProfilePFDto(element.initiatorCpfCnpj) as profilePFDto">
                    {{ profilePFDto.name }}
                    @if(profilePFDto.certifiedHubMedical) {
                    <img src="assets/icons/icon_certificado_concedido.svg" alt="Certificado Hub Medical"
                      matTooltip="Certificado Hub Medical" width="20px" height="20px" />
                    } @else {
                    <img src="assets/icons/icon_certificado_ausente.svg" alt="Não certificado"
                      matTooltip="Não certificado" width="20px" height="20px" />
                    }
                  </ng-container>
                  } @else {
                  <ng-container *ngIf="getCompanyDto(element.initiatorCpfCnpj) as companyDto">
                    {{ companyDto.companyName }}
                    @if(companyDto.certifiedHubMedical) {
                    <img src="assets/icons/icon_certificado_concedido.svg" alt="Certificado Hub Medical"
                      matTooltip="Certificado Hub Medical" width="20px" height="20px" />
                    } @else {
                    <img src="assets/icons/icon_certificado_ausente.svg" alt="Não certificado"
                      matTooltip="Não certificado" width="20px" height="20px" />
                    }
                  </ng-container>}</td>
              </ng-container>

              <ng-container matColumnDef="recipientCpfCnpj">
                <th mat-header-cell *matHeaderCellDef>Destinatário:</th>
                <td mat-cell *matCellDef="let element">
                  @if(element.initiatorCpfCnpj.length === 11) {
                  <ng-container *ngIf="getProfilePFDto(element.initiatorCpfCnpj) as profilePFDto">
                    {{ profilePFDto.name }}
                    @if(profilePFDto.certifiedHubMedical) {
                    <img src="assets/icons/icon_certificado_concedido.svg" alt="Certificado Hub Medical"
                      matTooltip="Certificado Hub Medical" width="20px" height="20px" />
                    } @else {
                    <img src="assets/icons/icon_certificado_ausente.svg" alt="Não certificado"
                      matTooltip="Não certificado" width="20px" height="20px" />
                    }
                  </ng-container>
                  } @else {
                  <ng-container *ngIf="getCompanyDto(element.initiatorCpfCnpj) as companyDto">
                    {{ companyDto.companyName }}
                    @if(companyDto.certifiedHubMedical) {
                    <img src="assets/icons/icon_certificado_concedido.svg" alt="Certificado Hub Medical"
                      matTooltip="Certificado Hub Medical" width="20px" height="20px" />
                    } @else {
                    <img src="assets/icons/icon_certificado_ausente.svg" alt="Não certificado"
                      matTooltip="Não certificado" width="20px" height="20px" />
                    }
                  </ng-container>}</td>
              </ng-container>

              <ng-container matColumnDef="createdAt">
                <th mat-header-cell *matHeaderCellDef>Criado em:</th>
                <td mat-cell *matCellDef="let element">{{ element.createdAt | date : 'dd/MM/yyyy - HH:mm' }}</td>
              </ng-container>

              <ng-container matColumnDef="updatedAt">
                <th mat-header-cell *matHeaderCellDef>Atualizado em:</th>
                <td mat-cell *matCellDef="let element">{{ element.updatedAt | date : 'dd/MM/yyyy - HH:mm' }}</td>
              </ng-container>

              <ng-container matColumnDef="status">
                <th mat-header-cell *matHeaderCellDef>Status:</th>
                <td mat-cell *matCellDef="let element">
                  <span class="badge badge-success">{{ element.status | enumDescription }}</span>
                </td>
              </ng-container>

              <ng-container matColumnDef="buttons">
                <th mat-header-cell *matHeaderCellDef></th>
                <td mat-cell *matCellDef="let element">
                  <button mat-icon-button [matMenuTriggerFor]="menuClosed" [matBadge]="countNotRead(element.id)" 
                          [matBadgeHidden]="!countNotRead(element.id)">
                    <mat-icon>more_vert</mat-icon>
                  </button>
                  <mat-menu #menuClosed="matMenu">
                    <button mat-menu-item (click)="openDialogChat(element.id)">
                      <mat-icon>chat</mat-icon>
                      <span>Abrir Chat</span>
                    </button>
                  </mat-menu>
                </td>
              </ng-container>

              <tr mat-header-row *matHeaderRowDef="displayedColumnsClose" [class.tr_header]="isMobile"></tr>
              <tr mat-row *matRowDef="let row; columns: displayedColumnsClose"></tr>
            </table>
          </div>
        </ng-container>

        <ng-template #mobileClose>
          <div class="mobile-list">
            <div *ngIf="getNegotiationsClosed().length === 0" class="empty-state">
              <mat-icon>info</mat-icon>
              <p>Nenhuma negociação concluída</p>
            </div>

            <article *ngFor="let element of getNegotiationsClosed()" class="card" role="group">
              <div class="mobile-card-row">
                <span class="mobile-card-label">ID:</span>
                <span class="mobile-card-value">{{ element.id }}</span>
              </div>
              <div class="mobile-card-row">
                <span class="mobile-card-label">Iniciador:</span>
                <span class="mobile-card-value">{{ element.initiatorCpfCnpj }}</span>
              </div>
              <div class="mobile-card-row">
                <span class="mobile-card-label">Destinatário:</span>
                <span class="mobile-card-value">{{ element.recipientCpfCnpj }}</span>
              </div>
              <div class="mobile-card-row">
                <span class="mobile-card-label">Criado em:</span>
                <span class="mobile-card-value">{{ element.createdAt | date : 'dd/MM/yyyy - HH:mm' }}</span>
              </div>
              <div class="mobile-card-row">
                <span class="mobile-card-label">Atualizado em:</span>
                <span class="mobile-card-value">{{ element.updatedAt | date : 'dd/MM/yyyy - HH:mm' }}</span>
              </div>
              <div class="mobile-card-row">
                <span class="mobile-card-label">Status:</span>
                <span class="badge badge-success">{{ element.status! | enumDescription }}</span>
              </div>
              <div class="mobile-card-actions">
                <button mat-icon-button [matMenuTriggerFor]="menuMobileClosed" [matBadge]="countNotRead(element.id!)" 
                        [matBadgeHidden]="!countNotRead(element.id!)">
                  <mat-icon>more_vert</mat-icon>
                </button>
                <mat-menu #menuMobileClosed="matMenu">
                  <button mat-menu-item (click)="openDialogChat(element.id!)">
                    <mat-icon>chat</mat-icon>
                    <span>Abrir Chat</span>
                  </button>
                </mat-menu>
              </div>
            </article>
          </div>
        </ng-template>
      </div>
    </swiper-slide>
  </swiper-container> </div>
}